import React, {useEffect, useMemo, useState} from 'react';
import {Row, Col} from 'react-bootstrap';
import {t} from 'react-switch-lang';
import '../../app/Risks/test.scss';
import ExternalizationTable from "./components/table/Table";
import {Add} from '../../components/modals/ModalAdd';
import {useHistory, useParams} from 'react-router-dom';
import {
  deleteExternalization,
  getExternalizationTableColumns
} from '../../services/externalizations/externalizationService';
import SearchHeader from '../administration/department/pageHeader/PageHeader';
import Prompt from '../../components/prompt/prompt';
import Toast from '../../components/toast/Toast';
import Swal from 'sweetalert2';
import EditExternalization from './sectorForms/components/externalizationForm/EditExternalization';
import roles from '../../utils/roles';
import {useUserContext} from '../../contexts/UserContext';
const Externalization = (props) => {
  const [updateTable, setUpdateTable] = useState(0);
  const [editAllow, setEditAllow] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [rowChanged, setRowChanged] = useState(false);
  const [search, setSearch] = useState('')
  const [allowCreate, setAllowCreate] = useState(false);
  const [allowDelete, setAllowDelete] = useState(false);
  const [allowEdit, setAllowEdit] = useState(false);

  let history = useHistory();
  const params = useParams();
  const user = useUserContext()
  const allowedRoles = [
    roles.role_user_in_charge_for_externalization
  ];
  const allowedRoleUserSector = [
    roles.role_risk_sector
  ];
  useEffect(() => {
    const roleUserSector = allowedRoleUserSector.filter((element) =>
      user?.authorities?.includes(element)
    );
    const result = allowedRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowCreate(result?.length > 0);
    setAllowEdit(roleUserSector?.length > 0);
    setAllowDelete(roleUserSector?.length > 0);
  }, [user]);
  const onExternalizationEdit = (item) => {
    setEditAllow(true);
    setSelectedItem(item);
  };
  const onExternalizationDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteExternalization'),
        text: t('question.deleteExternalization'),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteExternalization(record?.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess3', {
                  entity: t('externalization.externalization'),
                }),
                icon: 'success',
              });
              resolve(response);
              setUpdateTable((prevState) => prevState +1);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('Pages.messages.deleteError'),
              icon: 'error',
            });
          }
        },
      });
    });
  };
  const columns = getExternalizationTableColumns(
    user,
    history,
    onExternalizationDelete,
    onExternalizationEdit,
    allowDelete,
    allowEdit
  );
  const onRowChange = () => {
    setRowChanged(!rowChanged);
    setSearch('');
    setUpdateTable(updateTable + 1);
  }
  const query = useMemo(() => {
    if (!search) return '';

    const encoded = encodeURIComponent(search.trim());
    return `search.contains=${encoded}`;
  }, [search]);
  return (
        <>
            <div className="mx-5">
                  <Row>
                      <Col xs="12" lg="12" className="mt-4">
                            <SearchHeader
                              placeholder={t('externalization.riskProponentForm.placeholder.search')}
                              button={ allowCreate && <Add id='externalization' />}
                              onChange={(e) => setSearch(e.target.value)}
                              searchValue={search}
                              showInput={true}
                              showButton={true}
                            />
                      </Col>
                    {editAllow && <EditExternalization data={selectedItem} id='externalization'
                                               setRowChanged={() => onRowChange()}
                                                       onClose={() => {
                                                         setEditAllow(false);
                                                         setSelectedItem(null);
                                                       }}/>}
                  </Row>
                    <ExternalizationTable
                      key={updateTable}
                      columns={columns}
                      sort={'sort=id,DESC'}
                      api={'/externalizations'}
                      query={query}
                      cycleId={params?.id}
                      onClickRow={(id) => {
                            history.push({
                              pathname: `/externalizations/${id}`,
                            });
                      }}
                    />
            </div>
        </>
    );
};

export default Externalization;

